import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-policy">
      <SEO
        title="Privacy Policy | ART Aesthetics & Skincare"
        description="Read the ART Aesthetics & Skincare privacy policy, including GDPR rights, data usage, cookies, and contact information."
        path="/privacy"
      />
      <button onClick={() => navigate('/')} className="back-button">← Back to Home</button>
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p><strong>Last Updated: {new Date().getFullYear()}</strong></p>
        
        <section>
          <h2>1. Introduction</h2>
          <p>Art Aesthetics ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information in accordance with UK GDPR and Data Protection Act 2018 regulations.</p>
        </section>

        <section>
          <h2>2. Data We Collect</h2>
          <p>We may collect personal information when you interact with our website:</p>
          <ul>
            <li><strong>Contact Forms:</strong> Name, email address, phone number (if provided), and message content</li>
            <li><strong>Cookies:</strong> Browser information and session data via cookie consent banner</li>
            <li><strong>Usage Data:</strong> IP address, browser type, pages visited (for website analytics)</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Data</h2>
          <p>Your data is used for:</p>
          <ul>
            <li>Responding to your inquiries and contact form submissions</li>
            <li>Improving our services and website functionality</li>
            <li>Communicating with you about our treatments and business updates</li>
            <li>Complying with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>4. Third-Party Services & External Links</h2>
          <p>Our website contains links to external services that operate under their own privacy policies:</p>
          <ul>
            <li><strong>ThatTime Booking System:</strong> We use ThatTime for appointment scheduling. Any data you provide through their booking system is subject to <a href="https://thattime.io/privacy" target="_blank" rel="noopener noreferrer">ThatTime's Privacy Policy</a></li>
            <li><strong>Instagram:</strong> Links to our Instagram account direct you to Meta's platform, governed by <a href="https://www.instagram.com/about/legal/privacy/" target="_blank" rel="noopener noreferrer">Instagram's Privacy Policy</a></li>
            <li><strong>Google Maps:</strong> Our location embed uses Google Maps, subject to <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a></li>
          </ul>
          <p>We are not responsible for the privacy practices of these external services. We encourage you to review their privacy policies before sharing personal information.</p>
        </section>

        <section>
          <h2>5. Cookies</h2>
          <p>Our website uses cookies to enhance your browsing experience:</p>
          <ul>
            <li><strong>Consent Cookie:</strong> Stores your cookie consent preference (localStorage: 'cookiesAccepted')</li>
            <li><strong>Session Information:</strong> Temporary data to maintain your session while browsing</li>
          </ul>
          <p>You can control cookie settings through your browser preferences. Disabling cookies may affect website functionality.</p>
        </section>

        <section>
          <h2>6. Data Security</h2>
          <p>We implement appropriate security measures to protect your personal data:</p>
          <ul>
            <li>HTTPS encryption for all data transmission</li>
            <li>Server-side input validation and sanitization</li>
            <li>Rate limiting on contact forms to prevent abuse</li>
            <li>Security headers (Helmet.js) for additional protection</li>
            <li>Regular security monitoring and updates</li>
          </ul>
          <p>However, no method of transmission over the internet is 100% secure. We cannot guarantee absolute security of your data.</p>
        </section>

        <section>
          <h2>7. Data Retention</h2>
          <p>Contact form submissions and personal data are retained for as long as necessary to respond to your inquiries (typically 30 days) unless we require it for legal purposes or you request otherwise.</p>
        </section>

        <section>
          <h2>8. Your Rights (GDPR)</h2>
          <p>Under UK GDPR, you have the following rights:</p>
          <ul>
            <li><strong>Right to Access:</strong> Request a copy of your personal data</li>
            <li><strong>Right to Rectification:</strong> Request correction of inaccurate data</li>
            <li><strong>Right to Erasure:</strong> Request deletion of your data ("right to be forgotten")</li>
            <li><strong>Right to Restrict Processing:</strong> Request limitation of how we use your data</li>
            <li><strong>Right to Data Portability:</strong> Request your data in a portable format</li>
            <li><strong>Right to Object:</strong> Object to certain data processing activities</li>
          </ul>
          <p>To exercise any of these rights, please contact us using the information below.</p>
        </section>

        <section>
          <h2>9. Changes to This Policy</h2>
          <p>We may update this privacy policy from time to time. Changes will be posted on this page with an updated "Last Updated" date.</p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <p>If you have questions about our privacy practices or wish to exercise your GDPR rights, please contact us:</p>
          <p>
            <strong>Art Aesthetics</strong><br />
            Hughes Close, Widnes<br />
            Cheshire, WA8 5EJ<br />
            <a href="mailto:info@artaestheticsskincare.com">info@artaestheticsskincare.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
